import type { PublicSiteId } from '../utils/publicSite'

export interface SiteTerminology {
  managementCompanySingular: string
  managementCompanyPlural: string
  areasLabel: string
  areaSingular: string
  /** e.g. "an area" / "a patrol area" for empty-state copy */
  areaSingularIndefinite: string
  /**
   * Sidebar + list title for `/app/locations`.
   * ConstructionWalk: Sage job sites. Storage/Patrol: physical locations.
   */
  locationsLabel: string
}

const storageWalkTerminology: SiteTerminology = {
  managementCompanySingular: 'Management Company',
  managementCompanyPlural: 'Management Companies',
  areasLabel: 'Areas',
  areaSingular: 'Area',
  areaSingularIndefinite: 'an area',
  locationsLabel: 'Locations',
}

const patrolWalkTerminology: SiteTerminology = {
  managementCompanySingular: 'Security Company',
  managementCompanyPlural: 'Security Companies',
  areasLabel: 'Patrol Areas',
  areaSingular: 'Patrol Area',
  areaSingularIndefinite: 'a patrol area',
  locationsLabel: 'Locations',
}

const constructionWalkTerminology: SiteTerminology = {
  managementCompanySingular: 'Construction Company',
  managementCompanyPlural: 'Construction Companies',
  areasLabel: 'Job Sites',
  areaSingular: 'Job Site',
  areaSingularIndefinite: 'a job site',
  locationsLabel: 'Job Sites',
}

export function getSiteTerminology(siteId: PublicSiteId): SiteTerminology {
  switch (siteId) {
    case 'security-walk':
      return patrolWalkTerminology
    case 'construction-walk':
      return constructionWalkTerminology
    default:
      return storageWalkTerminology
  }
}
